








































































import { Component, Vue } from 'vue-property-decorator';
   @Component({ 
    })
export default class RemovePassengerModal extends Vue   {
  radios:boolean = true
  dialog:boolean= true;
  mockData:any[]=[];
  headers:any[]=[];



    created(){

        this.headers= [
          { text: 'Uçuş', value: 'flight' },
          { text: 'Uçuş Sınıfı', value: 'flightClass' },
          { text: 'Yolcu Durumu', value: 'passengerstatus' },
          { text: 'İsim', value: 'name' },
          { text: 'Yolcu Türü', value: 'passengerType' },
          { text: 'Pasaport', value: 'passport' },
          { text: 'Fiyat', value: 'price' },
          { text: 'Ceza Ücreti', value: 'penaltyFee' },

          
        ],

        this.mockData=[
          { 
            flight: '28755 - U6 1518',
            flightClass: 'X-A',
            passengerstatus: 'Ödeme alındı',
            name: 'AYNULA KAMBULATOV',
            passengerType:'Yetişkin',
            passport:'6716597327-860026',
            price:'1460 RUB',
            penaltyFee:'0 RUB',
          },
        ]




        

    }
  

    data () {
      return {



    }      

    
}
 

    closeDialog(){
      this.$emit('closed');
     
    }


};
